import { ImportOutlined } from "@ant-design/icons";
import { useTheme } from "@mui/material/styles";
import { Box, Divider, Paper, Stack, Typography } from "@mui/material";

import { SolidButton } from "components/buttons/SolidButton";
import RecentTransactionsBlock from "./RecentTransactionsBlock";

const formatNumber = (value) =>
  new Intl.NumberFormat("en-US").format(value || 0);

const Overview = ({
  dashboard,
  transactions,
  mspName,
  onShowTransactions,
  onImportCredits,
}) => {
  const theme = useTheme();

  return (
    <Stack spacing={3}>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{ height: "64px", mt: -1 }}
      >
        <Typography
          variant='h4'
          sx={{
            color: "#172664",
            fontFamily: theme.typography.fontFamily,
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          Overview
        </Typography>
        <Stack
          direction='row'
          alignItems='center'
          spacing={3}
          sx={{ height: "100%" }}
        >
          <Divider
            orientation='vertical'
            sx={{
              height: "40px",
              borderColor: "rgba(0,0,0,0.08)",
              borderRightWidth: "1px",
            }}
          />
          <SolidButton
            onClick={onImportCredits}
            startIcon={<ImportOutlined />}
            width='auto'
            height='36px'
            sx={{
              px: 3,
              borderRadius: "20px",
              bgcolor: "#172664",
              "&:hover": { bgcolor: "#23367d" },
            }}
          >
            Import Credits
          </SolidButton>
        </Stack>
      </Stack>
      <Paper variant='outlined' sx={{ p: 3, px: 5, borderRadius: "15px" }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent='space-between'
          spacing={3}
        >
          {[
            ["Current Balance", dashboard?.balance, "Credits"],
            ["Daily Usage", dashboard?.dailyUsage, "Credits / day"],
            ["Days Remaining", dashboard?.remainingDays, "Days"],
            [
              "Next Deduction",
              dashboard?.nextDeduction,
              dashboard?.nextDeductionAt
                ? new Date(
                    dashboard.nextDeductionAt * 1000,
                  ).toLocaleDateString()
                : "",
            ],
          ].map(([label, value, suffix]) => (
            <Box key={label} sx={{ minWidth: 150 }}>
              <Typography
                variant='body2'
                sx={{ color: "#262626", fontSize: "14px", fontWeight: "bold" }}
              >
                {label}
              </Typography>
              <Typography
                sx={{
                  color: "#008514",
                  fontSize: "35px",
                  fontWeight: "bold",
                  lineHeight: 1.2,
                }}
              >
                {formatNumber(value)}
              </Typography>
              <Typography
                variant='body2'
                sx={{ color: "#373737", fontSize: "13px", fontWeight: "bold" }}
              >
                {suffix}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Paper>
      <RecentTransactionsBlock
        transactions={transactions.slice(0, 10)}
        mspName={mspName}
        onShowMore={onShowTransactions}
      />
    </Stack>
  );
};

export default Overview;
